module.exports = __webpack_public_path__ + "img/northcampusdeck-h-474x356.17773d0e.jpg";